/**
 * Created by Josef Jurca on 19/01/2018.
 */
import _ from 'lodash';

import {
    convertForSetReminder,
    convertForRemoveReminder,
    convertForGetReminder,
    convertFromRead,
    convertFromListReminderRead
} from '../adapters/reminder';

import Reminder from 'models/reminder';

import {isValidResponse, hasReminder} from '../validators/reminder';

/**
 * Sets reminder for future asset.
 *
 * @param {number} assetId - Asset id.
 * @returns {Promise} Set reminder promise.
 */
export function setReminder (assetId) {
    const url = this._baseUrl + this._endPoints.setReminder;

    return this.read(
        {
            url: url,
            data: convertForSetReminder.call(this, assetId)
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(_.get(response, ['result', 'error']));
            }

            return new Reminder(convertFromRead(response));
        });
}

/**
 * Removes reminder for future asset.
 *
 * @param {number} reminderId - Reminder id.
 * @returns {Promise} Set reminder promise.
 */
export function removeReminder (reminderId) {
    const url = this._baseUrl + this._endPoints.removeReminder;

    return this.read(
        {
            url: url,
            data: convertForRemoveReminder.call(this, reminderId)
        })
        .then(response => {
            let error;

            if (!isValidResponse(response)) {

                error = _.get(response, ['result', 'error']);

                return Promise.reject(error);
            }

            return response;
        });
}

/**
 * Gets reminder for future asset.
 *
 * @param {number} assetId - Asset id.
 * @returns {Promise} Set reminder promise.
 */
export function getReminder (assetId) {
    const url = this._baseUrl + this._endPoints.getReminder;

    return this.read(
        {
            url: url,
            data: convertForGetReminder.call(this, assetId)
        })
        .then(response => {
            let error;

            if (!isValidResponse(response)) {

                error = _.get(response, ['result', 'error']);

                return Promise.reject(error);
            }

            if (!hasReminder(response)) {

                return Promise.reject();
            }

            return new Reminder(convertFromListReminderRead(response));
        });
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/reminder.js